import { ReactNode } from 'react'
import { IconType } from 'react-icons'

export type ConfirmationStep = {
  label: string
  content: string
  loading?: boolean
  icon?: IconType
  requiresUserAction?: boolean
  CustomView?: ReactNode
  nextCallback?: () => void
}

export enum TransactionStatus {
  pending = 'pending',
  confirmed = 'confirmed',
  failed = 'failed',
  dropped = 'dropped',
}

export interface ITransaction {
  txHash: string
  name: string
  chainId: number
  status:
    | TransactionStatus.confirmed
    | TransactionStatus.failed
    | TransactionStatus.pending
    | TransactionStatus.dropped
  from: string
  addedTime: number
  confirmedTime?: number
}
